import React from 'react';

export function Star({ length, leading }: { length: number; leading?: string }) {
  return (
    <p className='body-12-regular' style={{ lineHeight: `${leading}` }}>
      {Array(length)
        .fill(0)
        .map(() => '✲')}
    </p>
  );
}
